var version = '6.6.0';

module.exports = version;
